import type { DialogSize } from "./Dialog";

export const SIZE_CLASS_MAP: Record<DialogSize, string> = {
  small: "sm:max-w-sm",
  medium: "sm:max-w-md",
  large: "sm:max-w-lg",
  fullScreen: "h-screen w-screen max-w-none rounded-none sm:max-w-none",
};
